import { NO_VALUE_DASH } from '@shared/constants/no-value-dash';
import { MdcGrid, MdcTypography } from 'ids-wc/dist/react/components';

const KeyValuePair = (props: {
  label: string;
  value: string | null;
  pairType?: 'title' | 'basic';
  className?: string;
}) => {
  const { label, value, className, pairType = 'basic' } = props;
  const _value = value || NO_VALUE_DASH;

  const labelVariant = pairType === 'title' ? 'subtitle1' : 'body2';
  const valueVariant = pairType === 'title' ? 'headline5' : 'headline6';

  return (
    <MdcGrid row className={className}>
      <MdcGrid col="flex">
        <MdcTypography text={label} variant={labelVariant} color="textSecondary" />
        <MdcTypography text={_value} variant={valueVariant} color="textPrimary" />
      </MdcGrid>
    </MdcGrid>
  );
};

export default KeyValuePair;
